import { useMemo } from "react";
import useModuleInfo from "./useModuleInfo";

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

function useModuleSubscription(moduleIdentifier) {
  const { module, loading } = useModuleInfo();

  const moduleStatus = useMemo(() => {
    const requestedIdentifier = normalize(moduleIdentifier);
    if (!requestedIdentifier) {
      return {
        hasModule: false,
        hasActiveModule: false,
        hasTrialModule: false,
        hasExpiredTrialModule: false,
      };
    }

    const moduleSubscriptions = module?.moduleSubscriptions || [];
    const matchingModules = moduleSubscriptions.filter(
      (module) => normalize(module?.id) === requestedIdentifier,
    );

    const hasActiveModule = matchingModules.some((module) => module?.isActive);
    const hasTrialModule = matchingModules.some((module) => module?.isInTrial);

    const hasExpiredTrialModule = matchingModules.some((module) => {
      if (module?.isActive) return false;
      if (!module?.trialEndsAt) return false;
      return new Date(module.trialEndsAt) < new Date();
    });

    return {
      hasModule: hasActiveModule || hasTrialModule,
      hasActiveModule,
      hasTrialModule,
      hasExpiredTrialModule,
    };
  }, [moduleIdentifier, module?.moduleSubscriptions]);

  return {
    hasModule: moduleStatus.hasModule,
    hasActiveModule: moduleStatus.hasActiveModule,
    hasTrialModule: moduleStatus.hasTrialModule,
    hasExpiredTrialModule: moduleStatus.hasExpiredTrialModule,
    loading,
  };
}

export default useModuleSubscription;
